import AntdRadio   from 'antd/lib/radio';
import RadioGroup  from '@widesk-ui/components/form/RadioGroup';
import RadioButton from '@widesk-ui/components/form/RadioButton';
import React       from 'react';

export type RadioProps = Omit<FieldProps, 'placeholder'> & {
	checked?: boolean;
	children?: React.ReactNode;
}

function Radio(props: RadioProps) {
	return (
		<AntdRadio
			disabled={props.disabled}
			id={props.id}
			onChange={props.onChange}
			size={props.size}
			style={props.style}
			value={props.value}

			checked={props.checked}

			{...props}
		/>
	);
}

Radio.Group = RadioGroup;

Radio.Button = RadioButton;

export default Radio;
